import Tone from 'tone';
import {trigger, lazy} from './lang.js';
import {alt} from './alt.js';
let TIME_32N = new Tone.Time('32n');

export const time = (...x) => {
    for (let i in x) {
        if (Array.isArray(x[i])) {
            x[i] = alt(...x[i]);
        } 
    }
    let alty = alt(...x);
    if (x[0] && Array.isArray(x[0])) {
        alty = alt(...x[0]);
    }
    return (stepData, stepNumber, time, effect) => {
        let _time = effect.currentTime;
        _time += TIME_32N * lazy(alty, stepData, stepNumber, time, effect);
        return trigger({
            stepData,
            stepNumber,
            time: _time
        });
    };
};
